<template>
  <div class="content">
    <div :class="{bg: true, empty: list.length === 0}">
      <interviewFilter ref="interviewFilter" @getData="getFilter" :showCreate="showCreate" />
      <div class="list">
        <div class="titles">
          <span class="theme">主题</span>
          <span class="publisher">发布者</span>
          <span class="locate">地点</span>
          <span class="status">状态</span>
          <span class="time">开始/结束时间</span>
          <span class="upload">上传</span>
          <span class="handles">操作</span>
        </div>
        <empty :mTop="30" :msg="`暂无${$_syscfg.interview}数据`" v-if="list && list.length === 0" />
        <div class="items" v-for="(i, d) in list" :key="d">
          <div class="item">
            <span class="theme" @click="handleGo(i)">
              <p class="words" :title="i.title">
                {{i.title}}
              </p>
              <span class="msgIcon" v-if="i.remark">
                <img src="@assets/img/interview/msg.svg" alt="msg">
                <div class="msgContent">
                  <p>{{i.remark}}</p>
                </div>
              </span>
              <img src="@assets/img/interview/new.svg" alt="new" v-if="i.is_new == 1">
              <img v-if="i.has_expand" class="cameraG" src="@assets/img/interview/cameraG.png" alt="camera">
              <span v-if="i.expand_icon && i.expand_icon.has_icon" class="backIcon">
                <img src="@assets/img/interview/back.png" alt="msg">
                <div class="backContent">
                  <p>{{i.expand_icon.msg}}</p>
                </div>
              </span>
              <img src="@assets/img/interview/alert.svg" alt="warn" v-if="i.has_change == 1">
            </span>
            <span class="publisher">{{i.user_name}}</span>
            <span class="locate">{{i.address}}</span>
            <span class="status">
              <div class="process">
                <div :class="{rate: true, rateComplete: i.status == 3, rateReturn: i.status == 4}" :style="{width: i.status - 0 >= 3 ? '100%' : (i.status - 0 + 1)/4*100 + '%'}"></div>
              </div>
              <span :class="{stage: true, stageComplete: i.status == 3, stageReturn: i.status == 4}">
                {{i.status_name}}
              </span>
            </span>
            <span class="time">
              <span>{{i.start}}</span>
              <span>{{i.end}}</span>
            </span>
            <span class="upload">{{i.upload_content_num}}</span>
            <span class="handles">
              <span class="btn" v-if="i.has_cancel" @click="goCancel(i)">撤回</span>
              <span class="btn" v-if="i.has_edit" @click="goEdit(i.id)">
                编辑
              </span>
              <span class="btn" v-if="i.has_del" @click="goDelete(i.id)">
                删除
              </span>
              <span class="btn green" v-if="(i.status == 2 || i.status == 3) && i.has_material_role" @click="goClue(i)">
                上传
              </span>
            </span>
          </div>
        </div>
      </div>
      <pages :page_count="page.page_count" :index="page.pageIndex" :total="page.total"></pages>
    </div>
  </div>
</template>

<script>
import interviewFilter from '@components/interviewFilter'
import pages from '@components/pages'
import common from '@common/common'
import {apis} from '@common/config'
import empty from '@components/empty'
import dc from '@common/dc'

export default {
  name: 'allInterviews',
  components: {
    interviewFilter, pages, empty
  },
  data() {
    return {
      page: {
        page_count: 0,
        pageSize: 10,
        pageIndex: 1,
        total: 0
      },
      list: [],
      searchOptions: {},
      filterOptions: {},
      showCreate: false
    }
  },
  methods: {
    goClue(i) {
      // 去创建线索页
      // const d = {
      //   id: i.id,
      //   title: i.title
      // }
      //
      // this.$router.push({
      //   name: 'creatClue',
      //   params: {
      //     interview: d
      //   }
      // })
      dc.setItv(i)

      common.jump('/creatClue', true)

      setTimeout(() => {
        dc.delItv()
      }, 0)
    },
    goCancel(i) {
      // 撤销操作
      const info = {
        iview_id: i.id
      }

      common.myFetch(apis.Itv_cancel, info)
      .then(r => {
        if (r) {
          this.$toast(r)
          this.getList()
        }
      })
    },
    getList(keyWord) {
      const id = this.$route.params.id
      const info = {
        idstring: id,
        search_option: '',
        key_words: '',
        start: '',
        end: '',
        status: '',
        has_material: '',
        page: this.page.pageIndex,
        pagesize: this.page.pageSize
      }

      if(keyWord == 'noKeyWord'){
        this.searchOptions.key_words = ''
      }else{  
        this.searchOptions.key_words = this.$store.state.keyWord
      }

      Object.assign(info, this.searchOptions, this.filterOptions)

      common.myFetch(apis.Itv_my, info)
      .then((data) => {
        this.list = data.list
        this.generateSearchs(data.params.top_search.option.list)
        this.generateFilters(data.params.list_search)
        this.$set(this.page, 'page_count', common.calculatePage(data.page.row_count - 0, this.page.pageSize))
        this.$set(this.page, 'total', data.page.row_count - 0)
        this.showCreate = data.has_add_role
      })
    },
    generateFilters(data) {
      const filters = data.filter((i) => {
        return i.key !== 'start' && i.key !== 'end'
      })

      this.$refs.interviewFilter.filters = filters
    },
    generateSearchs(data) {
      const types = data.map((i) => {
        return {
          name: i.title,
          code: i.key,
          selected: i.selected
        }
      })

      const filterData = {
        types: types,
        callback: (o) => {
          this.getSearch(o)
        }
      }
      this.postSearch(filterData)
    },
    getFilter(data) {
      this.filterOptions = data
      this.getList()
    },
    getSearch(d) {
      this.searchOptions = d
      this.page.pageIndex = 1
      this.getList()
    },
    postSearch(data) {
      this.$emit('filterData', data)
    },
    handleGo(i) {
      const hasEdit = !!i.has_edit
      if (hasEdit) {
        this.goEdit(i.id)
      } else {
        this.goDetail(i.id)
      }
    },
    goDetail(i) {
      // this.$router.push({
      //   path: '/interviewDetail',
      //   query: {
      //     r: i
      //   }
      // })

      common.jump(`/interviewDetail?r=${i}`, true)
    },
    async goEdit(i) {
      const newWindow = window.open()
      common.checkPageStatus(i, 0).then(r => {
        if (r) {
          newWindow.location.href = `${window.location.origin}/editInterview?r=${i}`
        } else {
          newWindow.close()
        }
      })
    },
    async goDelete(i) {
      const c = await this.$confirm('确认删除吗？')
      if (!c) return

      const info = {
        iview_id: i
      }

      common.myFetch(apis.Itv_interview_del, info, 'post')
      .then((data) => {
        if (data) {
          this.$toast(data)
          this.getList()
        }
      })
    }
  },
  mounted() {
    const params = this.$route.params
    Object.assign(this.filterOptions, params)

    this.getList('noKeyWord')
    // 默认使用当天数据
    // this.$refs.interviewFilter.initDate()
  }
}
</script>

<style lang="less" scoped src="@assets/css/interview/myInterviews.less"></style>
